export default __webpack_public_path__ + "static/media/c-web-logo-darkgray.4624c8c2.png";